import gettext from '@sdk/lang/gettext';

import { SeenByProps } from '@web/newsfeed/types/SeenByProps';
import Icon from '@web/assets/svg/Icons/32/newsfeed-blue.svg';
import { UserPreviewListModal } from '@web/newsfeed/components/UserPreviewListModal/UserPreviewListModal';
import { useGetSeenBy } from '@web/newsfeed/SeenBy/seenBy.hooks';

type Props = {
  isVisible: boolean;
  onClose: () => void;
} & SeenByProps;

export const SeenByModal = ({ isVisible, onClose, pageId, articleId, seenByCount }: Props) => {
  const { isLoading, data } = useGetSeenBy({ pageId, articleId, seenByCount });

  return (
    <UserPreviewListModal
      isVisible={isVisible}
      onClose={onClose}
      isLoading={isLoading}
      icon={<Icon />}
      title={gettext('Seen by')}
      users={data}
    />
  );
};
